import { APP_CHANGE_STATUS, APP_USERS_LIST, APP_USER_ADD, APP_USER_CLEAR_NOTIFICATIONS, APP_USER_DELETE, APP_USER_EDIT, APP_USER_GET, APP_USER_MARK_NOTIFICATIONS_READ, APP_USER_NOTIFICATIONS, APP_USER_ROLES, APP_USER_SEND_VERIFICATION, SET_UP_PASSWORD } from '../constants/api-path';
import httpClient from './http.interceptor';



/**
 * @param {page: number, pageSize: number, filters: any } formData
 * @returns Promise<any>
 */
export const getAppUsersAPI = (formData: any): Promise<any> => {
    return httpClient.post(APP_USERS_LIST, formData);
};

/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const getAppUserDetailsAPI = (id: string): Promise<any> => {
    return httpClient.get(APP_USER_GET+id);
};

/**
 * @param {formData: any } params
 * @returns Promise<any>
 */
export const addAppUserAPI = (formData: any): Promise<any> => {
    return httpClient.post(APP_USER_ADD, formData);
};

/**
 * @param {id: string formData: any } params
 * @returns Promise<any>
 */
export const updateAppUserAPI = (id: string, formData: any): Promise<any> => {
    return httpClient.put(APP_USER_EDIT + id, formData);
};


/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const sendVerificationLinkAPI = (id: string): Promise<any> => {
    return httpClient.get(APP_USER_SEND_VERIFICATION + id);
};


/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const deleteAppUserAPI = (id: string | number): Promise<any> => {
    return httpClient.delete(APP_USER_DELETE + id);
}

/**
 * @param {formData: {status: string} } params
 * @returns Promise<any>
 */
export const changeStatusAppUserAPI = (id: string, formData: {status: number}): Promise<any> => {
    return httpClient.put(APP_CHANGE_STATUS + id, formData);
};

/**
 * @param {token: string, password: string } formData
 * @returns Promise<any>
 */
export const setupPasswordAPI = (formData: any): Promise<any> => {
    return httpClient.post(SET_UP_PASSWORD, formData);
};


/**
 * @returns Promise<any>
 */
export const getRolesListAPI = (): Promise<any> => {
    return httpClient.get(APP_USER_ROLES);
};

/**
 * @returns Promise<any>
 */
export const getNotificationAPI = (): Promise<any> => {
    return httpClient.get(APP_USER_NOTIFICATIONS);
};

/**
 * @returns Promise<any>
 */
export const clearNotificationAPI = (): Promise<any> => {
    return httpClient.delete(APP_USER_CLEAR_NOTIFICATIONS);
};

/**
 * @returns Promise<any>
 */
export const markNotificationsAsReadAPI = (): Promise<any> => {
    return httpClient.patch(APP_USER_MARK_NOTIFICATIONS_READ);
};
